<template>
  <form
    data-vv-scope="verify-otp"
    @submit.prevent="action('verify-otp')"
  >
    <div class="number-prefix">
      <input
        class="col-12 form-control login-signup-input border-dashed w-75 mx-auto"
        type="text"
        :placeholder="formData.otpAgent.toLowerCase() === 'email' ?
         formData.email : formData.phoneno"
        data-ismobileonly="false"
        name="username"
        id="verify-otp-phn-text"
        disabled
								data-test="verifyOtpFormEmailPhnInput"
      >
      <hr>
      <input
        class="col-12 form-control login-signup-input otp-code-input mx-auto"
        type="text"
        id="verify-otp-text"
        autocomplete="off"
        placeholder="Enter the OTP"
        data-ismobileonly="false"
        name="otp"
        v-model="otp"
        maxlength="6"
        @keypress="isNumValid($event)"
        @paste="cleanPhoneNumber"
								data-test="verifyOtpFormOtpInput"
      >
      <!--<div class="invalid-feedback"-->
      <!--v-if="showOtpError"-->
      <!--v-show="errors.has('verify-otp.otp')"-->
      <!--id="verify-otp-error"-->
      <!--&gt;-->
      <!--{{errors.first('verify-otp.otp')}}-->
      <!--</div>-->
    </div>
    <a
      class="text-center mx-auto d-block mt-3"
      href="#"
      @click.prevent="reSendOtp()"
      id="verify-otp-resend"
						data-test="verifyOtpFormResentLink"
    >
      Resend OTP
    </a>
    <a
      class="text-center mx-auto d-block mt-3"
      href="#"
      @click.prevent="cancelVerification()"
      id="verify-otp-change-phn"
						data-test="verifyOtpFormChangeLink"
    >
      Change
      {{formData.otpAgent.toLowerCase() === 'email' ?'Email' : 'Phone No.'}}
    </a>
    <button
      class="btn col-12 blue-btn continue-btn mt-3 mb-2"
      id="verify-otp-continue-btn"
						data-test="verifyOtpFormContinueBtn"
    >
      Continue
    </button>
  </form>
</template>

<script>
import Vue from 'vue'

export default {
	name: 'verify-otp-form',
	props: {
		formData: Object
	},
	computed: {
	},
	mounted () {
		this.otpFormData = this.formData
		this.$root.$on('ResetVerifyOtp', () => {
			//
			this.otpFormData = {
				otpAgent: '',
				phoneno: '',
				email: ''
			}
			this.otp = ''
		})
	},
	data () {
		return {
			otpFormData: {
				otpAgent: '',
				phoneno: '',
				email: ''
			},
			placeHolder: '',
			otp: '',
			showOtpError: false
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.showOtpError = false
					this.verifyOtp()
				} else {
					this.showOtpError = true
				}
			})
		},
		cancelVerification () {
			this.otp = ''
			this.$emit('cancelOtp')
		},
		reSendOtp () {
			Vue.toasted.show('OTP send successfully. ', { position: 'top-center' })
			this.otp = ''
			this.$emit('resendOtp')
		},
		verifyOtp () {
			const otpData = {
				otpAgent: this.formData.otpAgent.toLowerCase(),
				phoneno: this.formData.phoneno,
				email: this.formData.email,
				otp: this.otp
			}
			this.otpFormData = {}
			this.$emit('verifyOtp', otpData)
		},
		isNumValid (evt) {
			const charCode = (evt.which) ? evt.which : event.keyCode
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				evt.preventDefault()
				return false
			}

			return true
		},
		cleanPhoneNumber (e) {
			e.preventDefault()
			var pastedText = ''
			if (window.clipboardData && window.clipboardData.getData) {
				pastedText = window.clipboardData.getData('Text')
			} else if (e.clipboardData && e.clipboardData.getData) {
				pastedText = e.clipboardData.getData('text/plain')
			}
			this.otp = pastedText.replace(/\D/g, '')
		}
	}
}
</script>
